import React from "react";
import PropTypes from "prop-types";
import { Link, Redirect } from "react-router-dom";
import TextInput from "../../../components/Form/components/TextInput";
import DateTextInput from "../../../components/Form/components/TextInput/DateTextInput";
import SelectInput from "../../../components/Form/components/SelectInput";
import ApiStatsDetails from "./components/ApiStatsDetails";
import MembersApi from "../../../services/portal-api/MembersApi";
import moment from "moment/moment";
import $ from "jquery";
import AuthService from "../../../services/AuthService";
import { PulseLoader } from "react-spinners";

export default class ApiStatSection extends React.Component {
    constructor(props) {
        super(props);
        const urlParams = new URLSearchParams(window.location.search);
        this.state = {
            category: urlParams.get("type")
                ? urlParams.get("type")
                : "givex_api",
            errors: {},
            slug: "",
            detailShown: [],
            result: [],
            loadmore: false,
            offset: 0,
            limit: 50,
            isLoadingApis: true,
            filterColumn: urlParams.get("column")
                ? urlParams.get("column")
                : "",
            filterToken: urlParams.get("token") ? urlParams.get("token") : "",
            filterDateFrom: "",
            filterDateTo: "",
            screenh: "",
            graphTime: urlParams.get("graphTime")
                ? urlParams.get("graphTime")
                : "",
            viewMember: urlParams.get("viewMember")
                ? urlParams.get("viewMember")
                : "",
        };
    }

    componentDidMount() {
        // this.setState({
        //     category: 'givex_api',
        // },()=>{
        //     this.tableBuilder('givex_api');
        // });
        this.tableBuilder(this.state.category);
    }

    tableBuilder = (category) => {
        const localTime = new Date();
        let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let offset = localTime.getTimezoneOffset();
        if (this.state.viewMember == 1) {
            this.fetchErrors(category, tz, offset);
        } else {
            MembersApi.getApis(
                (response) => {
                    console.log(response);
                    if (response.success) {
                        let offset = this.state.limit + this.state.offset;
                        let loadmore = response.json.loadMore;
                        this.setState(
                            {
                                result: response.json.result,
                                category: category,
                                offset: offset,
                                loadmore: loadmore,
                                isLoadingApis: false,
                                screenh: window.innerHeight,
                            },
                            () => {
                                console.log("api", this.state);
                            }
                        );
                    } else {
                        this.setState(
                            {
                                isLoadingApis: false,
                            },
                            () => {
                                this.props.sessionLoadOut(response);
                            }
                        );
                    }
                },
                category,
                "",
                this.state.offset,
                this.state.filterColumn,
                this.state.filterToken,
                offset,
                tz,
                this.state.graphTime
            );
        }
    };

    fetchErrors = (category, tz, offset) => {
        MembersApi.getErrors(
            (response) => {
                if (response.success) {
                    let offset = this.state.limit + this.state.offset;
                    let loadmore = response.json.loadMore;
                    this.setState({
                        result: response.json.result,
                        category: category,
                        offset: offset,
                        loadmore: loadmore,
                        isLoadingApis: false,
                        screenh: window.innerHeight,
                    });
                } else {
                    this.setState(
                        {
                            isLoadingApis: false,
                        },
                        () => {
                            this.props.sessionLoadOut(response);
                        }
                    );
                }
            },
            this.state.category,
            this.state.offset,
            this.state.filterColumn,
            this.state.filterToken,
            offset,
            tz
        );
    };

    handleReset = (event) => {
        const category = this.state.category;
        this.setState(
            {
                errors: {},
                slug: "",
                detailShown: [],
                result: [],
                loadmore: false,
                offset: 0,
                limit: 50,
                isLoadingApis: true,
                filterColumn: "",
                filterToken: "",
                filterDateFrom: "",
                filterDateTo: "",
                screenh: "",
                viewMember: "",
            },
            () => {
                this.tableBuilder(category);
            }
        );
    };

    handleInput = (event) => {
        const errors = this.state.errors;
        const name = event.target.name;
        delete errors[name];
        let data = this.state;
        let category =
            event.target.type === "checkbox"
                ? event.target.checked
                : event.target.value;
        if (name == "api_type") {
            this.setState(
                {
                    errors: {},
                    slug: "",
                    loadmore: false,
                    offset: 0,
                    limit: 50,
                    isLoadingApis: true,
                    filterColumn: "",
                    filterToken: "",
                    filterDateFrom: "",
                    filterDateTo: "",
                    screenh: "",
                },
                () => {
                    this.tableBuilder(category);
                }
            );
        } else if (name == "filterBy") {
            const column = event.target.value;
            this.setState({
                filterColumn: column,
                filterToken: "",
            });
        } else {
            const token = event.target.value;
            if (name == "Date_To" || name == "Date_From") {
                if (name == "Date_From") {
                    this.setState(
                        {
                            filterDateFrom: token,
                        },
                        () => {
                            // let to = new Date(this.state.filterDateTo).toLocaleDateString('en-GB');
                            // let from = new Date(this.state.filterDateFrom).toLocaleDateString('en-GB');
                            // this.setState({
                            //     filterToken : from+"|"+to,
                            // });
                            let from = new Date(this.state.filterDateFrom);
                            let to = new Date(this.state.filterDateTo);
                            this.setState({
                                filterToken: `${new Date(
                                    this.state.filterDateFrom
                                ).toLocaleDateString(
                                    "en-GB"
                                )} ${from.toLocaleTimeString(
                                    "en-GB"
                                )}|${new Date(
                                    this.state.filterDateTo
                                ).toLocaleDateString(
                                    "en-GB"
                                )} ${to.toLocaleTimeString("en-GB")}`,
                            });
                        }
                    );
                } else {
                    this.setState(
                        {
                            filterDateTo: token,
                        },
                        () => {
                            // let to = new Date(this.state.filterDateTo).toLocaleDateString('en-GB');
                            // let from = new Date(this.state.filterDateFrom).toLocaleDateString('en-GB');
                            // this.setState({
                            //     filterToken : from+"|"+to,
                            // });
                            let from = new Date(this.state.filterDateFrom);
                            let to = new Date(this.state.filterDateTo);
                            this.setState({
                                filterToken: `${new Date(
                                    this.state.filterDateFrom
                                ).toLocaleDateString(
                                    "en-GB"
                                )} ${from.toLocaleTimeString(
                                    "en-GB"
                                )}|${new Date(
                                    this.state.filterDateTo
                                ).toLocaleDateString(
                                    "en-GB"
                                )} ${to.toLocaleTimeString("en-GB")}`,
                            });
                        }
                    );
                }
            } else {
                this.setState({
                    filterToken: token,
                });
            }
        }
    };

    handleLoadMore = (events) => {
        const localTime = new Date();
        let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let offset = localTime.getTimezoneOffset();
        this.setState({ isLoadingApis: true });
        const category = this.state.category;
        MembersApi.getApis(
            (response) => {
                console.log(response);
                if (response.success) {
                    const result = this.state.result;
                    response.json.result.forEach((kmm, index) => {
                        result.push(kmm);
                    });
                    let offset = this.state.limit + this.state.offset;
                    let loadmore = response.json.loadMore;
                    this.setState(
                        {
                            result: result,
                            category: category,
                            offset: offset,
                            loadmore: loadmore,
                            isLoadingApis: false,
                            screenh: window.innerHeight,
                        },
                        () => {
                            console.log("api", this.state);
                        }
                    );
                } else {
                    this.setState(
                        {
                            isLoadingApis: false,
                        },
                        () => {
                            this.props.sessionLoadOut(response);
                        }
                    );
                }
            },
            category,
            "",
            this.state.offset,
            this.state.filterColumn,
            this.state.filterToken,
            offset,
            tz,
            this.state.graphTime
        );
    };

    handleSubmit = (event) => {
        event.preventDefault();
        const localTime = new Date();
        let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let offset = localTime.getTimezoneOffset();
        const category = this.state.category;
        this.setState({ isLoadingApis: true, offset: 0, result: [] }, () => {
            MembersApi.getApis(
                (response) => {
                    if (response.success) {
                        let offset = this.state.limit + this.state.offset;
                        let loadmore = response.json.loadMore;
                        this.setState(
                            {
                                result: response.json.result,
                                offset: offset,
                                loadmore: loadmore,
                                isLoadingApis: false,
                                screenh: window.innerHeight,
                            },
                            () => {
                                console.log("api", this.state);
                            }
                        );
                    } else {
                        this.setState(
                            {
                                isLoadingApis: false,
                            },
                            () => {
                                this.props.sessionLoadOut(response);
                            }
                        );
                    }
                },
                category,
                "",
                this.state.offset,
                this.state.filterColumn,
                this.state.filterToken,
                offset,
                tz
            );
        });
    };

    convertUTCToLocalTime = (dateString) => {
        let date = new Date(dateString);
        const milliseconds = Date.UTC(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds()
        );
        const localTime = new Date(milliseconds);

        let cd =
            localTime.getFullYear() +
            "-" +
            (localTime.getMonth() + 1) +
            "-" +
            localTime.getDate() +
            " " +
            localTime.getHours() +
            ":" +
            localTime.getMinutes() +
            ":" +
            localTime.getSeconds();
        return moment(cd).format("DD/MM/YYYY h:mm A");
    };

    toggleShown = (event) => {
        let shownState = this.state.detailShown.slice();
        let index = shownState.indexOf(event.target.getAttribute("data-tran"));
        if (index >= 0) {
            shownState.splice(index, 1);
            this.setState(
                {
                    detailShown: shownState,
                    screenh: window.innerHeight,
                },
                () => {
                    console.log(this.state);
                }
            );
        } else {
            shownState.push(event.target.getAttribute("data-tran"));
            this.setState(
                {
                    detailShown: shownState,
                    screenh: window.innerHeight,
                },
                () => {
                    console.log(this.state);
                }
            );
        }
    };

    render() {
        let api_typs = [
            { key: "givex_api", value: "Givex" },
            { key: "futura_api", value: "Futura" },
            { key: "dotdigital_api", value: "DotDigital" },
        ];
        let apis = [];
        let selections = [
            { key: "Email", value: "Email" },
            { key: "Card", value: "Card No." },
            { key: "Date", value: "Date Range" },
            { key: "status", value: "Status" },
        ];
        let statusia = [
            { key: "success", value: "Success" },
            { key: "failed", value: "Failed" },
        ];
        let title =
            this.state.category == "givex_api"
                ? "Givex API Stats"
                : this.state.category == "futura_api"
                ? "Futura API Stats"
                : this.state.category == "dotdigital_api"
                ? "DotDigital API Stats"
                : "";
        let filters = (
            <form onSubmit={this.handleSubmit}>
                <div className="col">
                    <div className="col-5 gutter--40">
                        <div className="col">
                            <SelectInput
                                name="api_type"
                                label="Select an Api Service"
                                options={api_typs}
                                value={this.state.category}
                                onChange={this.handleInput}
                                required={true}
                            />
                        </div>
                        <div className="col">
                            <SelectInput
                                name="filterBy"
                                label="Search By"
                                options={selections}
                                value={this.state.filterColumn}
                                onChange={this.handleInput}
                                disabled={false}
                            />
                        </div>
                        {this.state.filterColumn == "status" && (
                            <div className="col">
                                <SelectInput
                                    name="status"
                                    label="Status"
                                    options={statusia}
                                    value={this.state.filterToken}
                                    onChange={this.handleInput}
                                    disabled={false}
                                />
                            </div>
                        )}
                        {this.state.filterColumn == "Email" && (
                            <div className="col">
                                <TextInput
                                    name="email"
                                    label="Email"
                                    placeholder="Enter .."
                                    value={this.state.filterToken}
                                    onChange={this.handleInput}
                                    required={true}
                                />
                            </div>
                        )}
                        {this.state.filterColumn == "Card" && (
                            <div className="col">
                                <TextInput
                                    name="rewards_card_number"
                                    label="Card No"
                                    placeholder="Enter .."
                                    value={this.state.filterToken}
                                    onChange={this.handleInput}
                                    required={true}
                                />
                            </div>
                        )}
                        {this.state.filterColumn == "Date" && (
                            <div className="col">
                                <DateTextInput
                                    name="Date_From"
                                    label="Date From"
                                    type="datetime-local"
                                    placeholder="DD/MM/YYYY"
                                    value={this.state.filterDateFrom}
                                    onChange={this.handleInput}
                                />
                            </div>
                        )}
                        {this.state.filterColumn == "Date" && (
                            <div className="col">
                                <DateTextInput
                                    name="Date_To"
                                    label="Date To"
                                    type="datetime-local"
                                    placeholder="DD/MM/YYYY"
                                    value={this.state.filterDateTo}
                                    onChange={this.handleInput}
                                />
                            </div>
                        )}

                        {this.state.filterColumn != "" && (
                            <div className="col" style={{ paddingTop: 41 }}>
                                <button
                                    type="submit"
                                    className="btn btn--small btn--color"
                                    style={{ marginRight: 6 }}
                                >
                                    Search
                                </button>
                                <button
                                    className="btn btn--small btn--color"
                                    onClick={this.handleReset}
                                >
                                    Reset
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </form>
        );

        this.state.result.forEach((api, index) => {
            console.log(typeof api.id);
            apis.push(
                <React.Fragment key={index}>
                    <tr>
                        <td style={{ background: "#f3f7eb" }}>
                            <span
                                data-tran={api.id}
                                onClick={this.toggleShown}
                                style={{
                                    border: "1px solid #a9a9a9",
                                    padding: 2,
                                    background: "#fff",
                                    marginRight: 14,
                                    paddingLeft: 5,
                                }}
                            >
                                {" "}
                                {this.state.detailShown.includes(
                                    api.id.toString()
                                )
                                    ? " - "
                                    : " + "}{" "}
                            </span>
                            <strong data-col="Transaction_No">
                                {api.service}
                            </strong>
                        </td>
                        <td style={{ background: "#f3f7eb" }}>
                            <strong data-col="Card_No">{api.status}</strong>
                        </td>
                        <td style={{ background: "#f3f7eb" }}>
                            <strong>
                                {this.convertUTCToLocalTime(api.created_at)}
                            </strong>
                        </td>
                    </tr>
                    <React.Fragment>
                        {this.state.detailShown.includes(api.id.toString()) && (
                            <tr>
                                <td colSpan="3">
                                    <ApiStatsDetails
                                        paylowd={api.payload}
                                        respownse={api.response}
                                    ></ApiStatsDetails>
                                </td>
                            </tr>
                        )}
                    </React.Fragment>
                </React.Fragment>
            );
        });

        $(document).ready(function () {
            $(".scrollToTop").hide();
            console.log(window.innerHeight);
            //Check to see if the window is top if not then display button
            $(window).scroll(function () {
                if ($(this).scrollTop() > 300) {
                    console.log("sd");
                    $(".scrollToTop").show();
                } else {
                    $(".scrollToTop").hide();
                }
            });
        });

        let loaderOffset = {
            top: 200,
            position: "absolute",
            left: "50%",
        };

        if (this.state.offset != 0) {
            loaderOffset = {
                bottom: 400,
                position: "absolute",
                left: "50%",
            };
        }

        return (
            AuthService.can("API logs") && (
                <div>
                    <div className="col gutter--40">
                        <div className="col">{filters}</div>
                        <div
                            className="col"
                            style={{ borderBottom: "1px solid #ccc" }}
                        >
                            <div className="col">
                                <h2
                                    className="text--light text--color text--40 margin--40--top"
                                    style={{ float: "left" }}
                                >
                                    {title}
                                </h2>
                            </div>
                            <div
                                className="col"
                                style={{
                                    position: "absolute",
                                    zIndex: 999,
                                    left: "calc(50% - 65px)",
                                    bottom: 130,
                                }}
                            ></div>
                        </div>
                    </div>
                    <div
                        className="table--overflow clearfix"
                        style={{ overflowY: "auto" }}
                    >
                        {/* {this.state.isLoadingApis &&
                        <div style={{
                            position: 'fixed',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            height: '50%',
                            width: '50%',
                            background: '#fff',
                            zIndex: 7777,
                            opacity: 0.8,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }} >
                            <div className="sk-fading-circle" style={loaderOffset}>
                                <div className="sk-circle1 sk-circle" />
                                <div className="sk-circle2 sk-circle" />
                                <div className="sk-circle3 sk-circle" />
                                <div className="sk-circle4 sk-circle" />
                                <div className="sk-circle5 sk-circle" />
                                <div className="sk-circle6 sk-circle" />
                                <div className="sk-circle7 sk-circle" />
                                <div className="sk-circle8 sk-circle" />
                                <div className="sk-circle9 sk-circle" />
                                <div className="sk-circle10 sk-circle" />
                                <div className="sk-circle11 sk-circle" />
                                <div className="sk-circle12 sk-circle" />
                            </div>
                        </div>
                    } */}
                        <table>
                            <thead>
                                <tr>
                                    <td>Service</td>
                                    <td>Status</td>
                                    <td>Date & time</td>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.isLoadingApis ? (
                                    <PulseLoader color="#000" size={5} />
                                ) : (
                                    apis
                                )}
                                {apis.length === 0 && (
                                    <tr>
                                        <td colSpan="3">No results founds.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        {this.state.loadmore && (
                            <button
                                onClick={this.handleLoadMore}
                                style={{
                                    position: "relative",
                                    left: "50%",
                                    bottom: 20,
                                    marginTop: 60,
                                    zIndex: 9999,
                                    padding: "5px 5px 5px",
                                    fontSize: 12,
                                    borderRadius: 23,
                                    background: "#2170c3",
                                    fontWeight: 600,
                                    color: "white",
                                    width: 112,
                                    boxShadow: "0px 0px 6px #58626c",
                                }}
                            >
                                load more
                            </button>
                        )}
                    </div>
                </div>
            )
        );
    }
}
